<template>
  <div class="local-sign-path-test-page">
    <el-card class="test-card">
      <div slot="header" class="card-header">
        <span>CA 本地路径签章测试</span>
        <el-button size="small" @click="$router.go(-1)">返回</el-button>
      </div>

      <el-alert
        title="参考本地 HTML 示例：使用浏览器选择 PDF 文件并通过 pdfBase64 传入，savePath 保持指定路径，签章后保存到本地。"
        type="warning"
        :closable="false"
        show-icon />

      <el-form label-width="120px" class="test-form">
        <el-form-item label="原文 PDF">
          <el-upload
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            accept=".pdf"
            :on-change="handlePdfFileChange">
            <el-button type="primary" :loading="selecting">选择文件</el-button>
          </el-upload>
          <div v-if="form.fileName" class="form-tip">已选择：{{ form.fileName }}</div>
        </el-form-item>

        <el-form-item label="保存路径 savePath">
          <el-input v-model="form.savePath" placeholder="签章后保存路径，例如 D:\\testfile\\sign.pdf" />
          <div class="form-tip">savePath 不随选择文件变化，点击签章后由 PDFClient 保存到该路径。</div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :disabled="!form.fileBase64" @click="viewPdf">打开签章页面</el-button>
          <el-button @click="resetViewer">清空</el-button>
        </el-form-item>
      </el-form>

      <el-divider />

      <div class="result-block">
        <h3>调用日志</h3>
        <el-tag v-if="lastSavePath" type="success">签章保存路径：{{ lastSavePath }}</el-tag>
        <pre class="log-panel">{{ logs.join('\n') }}</pre>
      </div>

      <div v-if="viewerUrl" class="viewer-wrapper">
        <iframe
          id="BJCAPdfJsViewer"
          ref="viewerFrame"
          :src="viewerUrl"
          frameborder="0"
          scrolling="auto"
          width="100%"
          :height="viewerHeight" />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CaLocalSignPathTest',
  data() {
    return {
      selecting: false,
      viewerUrl: '',
      viewerHeight: 600,
      lastSavePath: '',
      returnPath: '/ca-file-test',
      pdfPosted: false,
      signedBase64: '',
      logs: [],
      form: {
        openType: 'data',
        fileName: '',
        fileBase64: '',
        saveType: 'path',
        savePath: 'C:\\BJCAROOT\\pawdocs\\PDFClient\\sign.pdf',
        showPagingSealBtn: 1,
        showSignContentBtn: 1,
        showVerifyBtn: 1
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateViewerHeight)
    window.addEventListener('message', this.handleViewerMessage)
    this.updateViewerHeight()
    this.loadSignData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewerHeight)
    window.removeEventListener('message', this.handleViewerMessage)
  },
  methods: {
    addLog(text) {
      this.logs.unshift(`[${new Date().toLocaleTimeString()}] ${text}`)
    },
    loadSignData() {
      const memoryData = window.__caLocalSignPdfData
      const dataText = sessionStorage.getItem('caLocalSignPdfData')
      if (!dataText && !memoryData) {
        return
      }
      try {
        const data = memoryData || JSON.parse(dataText)
        this.form.fileName = data.fileName || ''
        this.form.fileBase64 = data.fileBase64 || ''
        this.form.savePath = data.savePath || this.form.savePath
        this.returnPath = data.returnPath || '/ca-file-test'
        this.addLog('已接收待签章文件：' + this.form.fileName)
        this.$nextTick(this.viewPdf)
      } catch (error) {
        this.addLog('读取签章文件数据失败：' + (error.message || error))
      }
    },
    handlePdfFileChange(file) {
      const rawFile = file && file.raw
      if (!rawFile) {
        this.$message.warning('文件不存在')
        return
      }
      if (rawFile.type && rawFile.type !== 'application/pdf') {
        this.$message.warning('请选择 PDF 文件')
        return
      }
      this.selecting = true
      const reader = new FileReader()
      reader.onload = () => {
        const result = reader.result || ''
        const base64 = String(result).includes(',') ? String(result).split(',').pop() : String(result)
        this.form.fileName = rawFile.name || ''
        this.form.fileBase64 = base64
        this.addLog('选择文件：' + this.form.fileName)
        this.selecting = false
      }
      reader.onerror = () => {
        this.selecting = false
        this.$message.error('读取文件失败')
        this.addLog('读取文件失败')
      }
      reader.readAsDataURL(rawFile)
    },
    postPdfBase64() {
      const iframe = this.$refs.viewerFrame && this.$refs.viewerFrame.contentWindow
      if (!iframe || !this.form.fileBase64) {
        return
      }
      if (this.pdfPosted) {
        return
      }
      iframe.postMessage({
        type: 'pdfBase64',
        contents: this.form.fileBase64
      }, 'http://127.0.0.1:21051')
      this.pdfPosted = true
      this.addLog('已发送 pdfBase64 到 PDFClient')
    },
    viewPdf() {
      if (!this.form.fileBase64) {
        this.$message.warning('请先选择 PDF 文件')
        return
      }
      const token = Math.random()
      const params = new URLSearchParams({
        openType: this.form.openType,
        savePath: this.form.savePath,
        saveType: this.form.saveType,
        token: String(token),
        showPagingSealBtn: String(this.form.showPagingSealBtn),
        showSignContentBtn: String(this.form.showSignContentBtn),
        showVerifyBtn: String(this.form.showVerifyBtn)
      })
      this.pdfPosted = false
      this.viewerUrl = `http://127.0.0.1:21051/PDFClient/viewer.html?${params.toString()}`
      this.addLog('打开签章页面：' + this.viewerUrl)
      this.$nextTick(() => {
        this.updateViewerHeight()
        const iframe = this.$refs.viewerFrame
      console.log('----------iframe');
       console.log(iframe);
        console.log('----------iframe');
      
        if (iframe) {
          iframe.onload = () => {
            this.postPdfBase64()
          }
        }
      })
    },
    handleViewerMessage(e) {
      const message = e.data || {}
      if (message && message.type) {
        this.addLog('PDFClient 消息：type=' + message.type + ' keys=' + JSON.stringify(Object.keys(message)))
      }
      if (message.type === 'initSucceeded') {
        this.addLog('PDFClient 初始化成功')
        this.postPdfBase64()
      } else if (message.type === 'signPdfBase64') {
        const base64 = message.contents || message.pdfBase64 || message.signPdfBase64 || ''
        if (base64) {
          this.signedBase64 = base64
          this.addLog('收到签章后 Base64，长度：' + base64.length)
        } else {
          this.addLog('signPdfBase64 消息不含内容：' + JSON.stringify(Object.keys(message)))
        }
      } else if (message.type === 'localSignSucceeded') {
        this.lastSavePath = message.savePath || ''
        this.addLog('本地签章保存成功：' + this.lastSavePath)
        if (window.__caLocalSignPdfData) {
          window.__caLocalSignPdfData.signedBase64 = this.signedBase64
        } else {
          window.__caLocalSignPdfData = { signedBase64: this.signedBase64 }
        }
        sessionStorage.setItem('caLocalSignResult', JSON.stringify({
          savePath: this.form.savePath,
          actualSavePath: this.lastSavePath || '',
          hasSignedBase64: !!this.signedBase64
        }))
        this.$message.success('签章成功，即将返回加密页面')
        setTimeout(() => {
          this.$router.replace(this.returnPath || '/ca-file-test')
        }, 800)
      }
    },
    updateViewerHeight() {
      this.viewerHeight = Math.max(document.documentElement.clientHeight - 260, 500)
    },
    resetViewer() {
      this.form.fileName = ''
      this.form.fileBase64 = ''
      this.viewerUrl = ''
      this.lastSavePath = ''
      this.pdfPosted = false
      this.signedBase64 = ''
      this.logs = []
    }
  }
}
</script>

<style scoped>
.local-sign-path-test-page {
  min-height: 100vh;
  padding: 24px;
  background: #f5f7fa;
}

.test-card {
  max-width: 1200px;
  margin: 0 auto;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.test-form {
  margin-top: 24px;
}

.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #e6a23c;
}

.result-block h3 {
  margin: 0 0 12px;
  font-size: 16px;
}

.log-panel {
  min-height: 120px;
  margin-top: 12px;
  padding: 12px;
  overflow: auto;
  color: #dcdfe6;
  background: #1f2d3d;
  border-radius: 6px;
  white-space: pre-wrap;
}

.viewer-wrapper {
  margin-top: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
}
</style>
